import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { mod } from '~/client/helpers/add-bem-modifiers';
import { replaceQueryParameters } from '~/shared/replace-query-parameters';
import type { CleanLink as Props } from './clean-link.types';
import { themes } from './clean-link.types';

const CleanLink: React.FC<React.PropsWithChildren<Props>> & {
  themes: typeof themes;
} = ({
  bold,
  children,
  className,
  elementName,
  href,
  text,
  theme,
  query,
  ...rest
}) => (
  <Text
    elementName={elementName}
    theme={bold ? Text.themes.emphasis : Text.themes.normal}
    size={Text.sizes.small}
  >
    <a
      className={[mod('clean-link', theme), className].join(' ')}
      href={replaceQueryParameters(href, query)}
      {...rest}
    >
      {text ? text : children ? children : null}
    </a>
  </Text>
);

CleanLink.themes = themes;

export default CleanLink;
